var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion10X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.974,4.768L29.27,0.222L48.222,20.274L27.656,40.222L23.55,35.483L36.021,23.388L-0.222,23.388L-0.222,16.959L36.496,16.959L24.974,4.768Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    transform: "rotate(180 24 20.222)",
    fill: "#1B1B1D",
    stroke: "#1B1B1D",
    strokeWidth: 1,
    strokeMiterlimit: 3.999327
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion10X2);
export default __webpack_public_path__ + "static/media/union_10_x2.347993b5504bf69efcec8df9ea369f62.svg";
export { ForwardRef as ReactComponent };